import { TmBaseError } from '@/core/error/tmBaseError'

export default class TmColumnManagerError extends TmBaseError {
  public name = 'TmColumnManagerError'
}
